import { render, staticRenderFns } from "./DashboardSessionsFilter.vue?vue&type=template&id=038c4452&scoped=true&"
import script from "./DashboardSessionsFilter.vue?vue&type=script&lang=js&"
export * from "./DashboardSessionsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038c4452",
  null
  
)

export default component.exports